import React from 'react';
import RecapCommande from 'components/organisms/RecapCommande';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { ErrorText } from 'components/atoms/Texts/ErrorText';
import { CommandeDefWithEleve } from 'types/commande/commande.def';

interface CommandeErrorMessageViewProps {
  commandes: CommandeDefWithEleve[];
}

export const CommandeErrorMessageView = ({
  commandes
}: CommandeErrorMessageViewProps) => {
  if (!commandes || commandes.length < 1)
    return (
      <FeatureContainer>
        <p>Vous n'avez aucune commande</p>
      </FeatureContainer>
    );
  return (
    <ContainerFullWidth>
      <FeatureContainer>
        <ErrorText text="Une erreur est survenue pendant l'enregistrement de votre commande. " />
        <p>
          Cette erreur est peut être sans incidence. Merci de vérifier que votre
          dernière commande (AFFICHÉE CI-DESSOUS) est bien celle que vous venez
          d'inscrire.
        </p>
        <p>
          Si tout est en ordre, veuillez cliquer sur le bouton "Aller sur la
          page mes commandes". Sinon merci de cliquer sur "Revenir" ou de
          contacter votre professeur
        </p>
      </FeatureContainer>
      <RecapCommande commande={commandes[0]} />
    </ContainerFullWidth>
  );
};
